import { CheckCircle2, Edit3, MoreHorizontal, XCircle } from 'lucide-react';
import { Button } from '../../atoms/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator } from '../../molecules/dropdown-menu';
import { EntryActionsMenuProps } from './interface';

/**
 * The Approve / Request Edit / Reject menu for one time entry row. Shared by
 * the Approvals queue and the admin All Entries tab — each caller supplies
 * its own handlers (and whether Reject applies), so one visual change here
 * (icon, color, wording, item order) reaches both.
 */
export function EntryActionsMenu({
  onApprove,
  approveDisabled,
  onRequestEdit,
  onReject,
  canReject = true,
}: EntryActionsMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          className="text-green-600 focus:text-green-600"
          disabled={approveDisabled}
          onClick={onApprove}
        >
          <CheckCircle2 className="h-4 w-4" />
          Approve
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onRequestEdit}>
          <Edit3 className="h-4 w-4" />
          Request Edit
        </DropdownMenuItem>
        {canReject && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem className="text-destructive focus:text-destructive" onClick={onReject}>
              <XCircle className="h-4 w-4" />
              Reject
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
